module.exports = __webpack_public_path__ + "static/media/facebook.c14da210.svg";